import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
import { AnimatedSection, staggerContainer, staggerItem } from './AnimatedSection';
interface ForAstrologersSectionProps {
  onNavigate: (page: string) => void;
}
export function ForAstrologersSection({
  onNavigate
}: ForAstrologersSectionProps) {
  return <AnimatedSection className="py-8 sm:py-20 bg-white" data-id="element-16851">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16852">
        <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl" data-id="element-16853">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 sm:gap-8" data-id="element-16854">
            <div className="p-5 sm:p-10 lg:p-14" data-id="element-16855">
              <span className="text-[10px] sm:text-xs font-bold text-amber-400 uppercase tracking-[0.2em] mb-2 sm:mb-4 block" data-id="element-16856">
                Для профессионалов
              </span>
              <h2 className="text-xl sm:text-3xl font-bold text-white mb-3 sm:mb-4" data-id="element-16857">
                Вы астролог?
              </h2>
              <p className="text-slate-400 mb-4 sm:mb-8 leading-relaxed text-xs sm:text-base" data-id="element-16858">
                Присоединяйтесь к платформе, находите клиентов. Мы берём на себя
                маркетинг и поддержку.
              </p>
              <ul className="space-y-2 sm:space-y-3 mb-4 sm:mb-8" data-id="element-16859">
                {['Бесплатная регистрация', '0% комиссии первый месяц', 'Встроенный чат с клиентами'].map((t, i) => <li key={i} className="flex items-center text-slate-300 text-xs sm:text-sm" data-id="element-16860">
                    <Check className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-emerald-400 mr-2 sm:mr-3 flex-shrink-0" data-id="element-16861" />{' '}
                    {t}
                  </li>)}
              </ul>
              <Button size="lg" variant="outline" className="bg-white border-0 hover:bg-slate-100 text-xs sm:text-sm" onClick={() => onNavigate('for-astrologers')} data-id="element-16862">
                Стать экспертом <ArrowRight className="ml-2 w-4 h-4" data-id="element-16863" />
              </Button>
            </div>
            <div className="hidden lg:flex items-center justify-center p-14" data-id="element-16864">
              <motion.div className="grid grid-cols-2 gap-4 w-full max-w-xs" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
              once: true
            }} data-id="element-16865">
                {[{
                num: '150+',
                label: 'Астрологов'
              }, {
                num: '300K ₽',
                label: 'Макс. доход/мес'
              }, {
                num: '50K+',
                label: 'Аудитория'
              }, {
                num: '4.9★',
                label: 'Рейтинг'
              }].map((s, i) => <motion.div key={i} variants={staggerItem} className="bg-white/[0.06] border border-white/[0.08] rounded-xl p-4 text-center" data-id="element-16866">
                    <div className="text-xl font-bold text-white mb-1" data-id="element-16867">
                      {s.num}
                    </div>
                    <div className="text-xs text-slate-400" data-id="element-16868">{s.label}</div>
                  </motion.div>)}
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}